<!-- チケット詳細/Passを開いた際、未引き換えの特急引換券を所持していたら開く -->
<template>
  <ItemDialog ref="dialogRef" image-type="alert">
    <template #content-area>
      <p class="text-center">
        <span>ご旅行前までに特急券の引き換えを</span>
        <span>おすすめします</span>
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogHasExchangeableCoupon",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
<style scoped lang="scss">
.text-center {
  text-align: center;
}

.text-center span {
  display: inline-block;
  white-space: nowrap;
  line-height: 20px;
}
</style>
